import cn from "@/utils/cn";

interface TextProps {
  type:
    | "title"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "body"
    | "caption"
    | "button"
    | "small";
  children: React.ReactNode;
  className?: string;
  renderHTML?: boolean;
  [key: string]: any;
}

const TextComponent: React.FC<TextProps> = ({
  type,
  children,
  className,
  renderHTML = false,
  ...props
}) => {
  const baseStyles: any = {
    title: "font-semibold",
    h1: "font-semibold",
    h2: "font-semibold",
    h3: "font-semibold",
    h4: "font-medium",
    body: "font-normal",
    caption: "font-normal",
    small: "font-normal",
    button: "font-semibold",
  };

  const textStyles = {
    title: `xl:text-[50px] text-[34px] `,
    h1: `xl:text-[40px] text-[27px]`,
    h2: `xl:text-[35px] text-[23px]`,
    h3: `xl:text-[18px] text-[13.5px]`,
    h4: `xl:text-[16px] text-[12px]`,
    body: `xl:text-[14px] text-[10.5px]`,
    caption: `xl:text-[12px] text-[9px]`,
    small: `xl:text-[10px] text-[7.5px]`,
    button: `xl:text-[16px] text-[12px]`,
  };

  // Only check for HTML if renderHTML prop is true
  const isHTML = (str: string) => {
    return typeof str === "string" && /<[a-z][\s\S]*>/i.test(str);
  };

  const linkStyles = `
    <style>
      a {
          color: #2563eb;
        }
    </style>
  `;

  // Only render HTML if renderHTML prop is true and content contains HTML
  if (renderHTML && typeof children === "string" && isHTML(children)) {
    return (
      <div
        className={cn(baseStyles[type], textStyles[type], className)}
        dangerouslySetInnerHTML={{ __html: linkStyles + children }}
        {...props}
      />
    );
  }

  return (
    <div
      className={cn(baseStyles[type], textStyles[type], className)}
      {...props}
    >
      {children}
    </div>
  );
};

export default TextComponent;
